
interface Pattern {
	CURRENCY: RegExp;
    DATE_REGEX: RegExp;
	DATE_MASK: RegExp;
	NUMERIC_VALUES_ONLY: RegExp;
    SPECIAL_CHARACTERS_ONLY: RegExp;
    NUMERIC_VALUES: RegExp;
    SPECIAL_CHARACTERS: RegExp;
    PASSWORD: RegExp;
	EMAIL: RegExp;
	FULL_SSN: RegExp;
	FULL_SSN_FORMATTED: RegExp;
	FULL_SSN_MASK: RegExp;
    LAST_4_SSN: RegExp;
	LAST_4_SSN_MASK: RegExp;
	NON_DECIMAL_DIGITS: RegExp;
    SINGLE_ALPHANUMERIC: RegExp;
    SINGLE_NUMERIC: RegExp;
    SIX_DIGIT: RegExp;
	PHONE: RegExp;
	PHONE_MASK: RegExp;
	SYSTEM_NUMBER_REGEX: RegExp;
	WEIGHT_MASK : RegExp;
	ZIPCODE_FULL: RegExp;
    ZIPCODE_FULL_MASK: RegExp;
    ZIPCODE: RegExp;
	ZIPCODE_MASK: RegExp;
    DATE_SHORT: RegExp;
    DATE_SHORT_CCEXPIRE: RegExp;
    DATE_SHORT_MASK: RegExp;
    REMOVE_PHONE_MASK: RegExp;
    REMOVE_SSN_MASK: RegExp;
    REMOVE_ZIPCODE_MASK: RegExp;
    DATE_MONTH: RegExp;
    DATE_DAY: RegExp;
    DATE_YEAR: RegExp;
} 

//  TODO: 2024
//  DATE_SHORT_CCEXPIRE - Update the min year from /(2[3-9]|3[0-9]) to /(2[4-9]|3[0-9])
//  Need to come up with something better
export const MaskPatterns: Pattern = {
    CURRENCY                 : /^\$?\-?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$/,
    DATE_REGEX               : /(\d{2})\/(\d{2})\/(\d{4})/,
    DATE_MASK                : /(\d{0,2})(\d{0,2})(\d{0,4})/,
    NUMERIC_VALUES_ONLY      : /^[0-9]*$/g,
    SPECIAL_CHARACTERS_ONLY  : /[^-+_!@#$%^&*.,?]/g,
    NUMERIC_VALUES           : /\d/,
    SPECIAL_CHARACTERS       : /[-+_!@#$%^&*.,?]/,
    PASSWORD                 : /^(?!.*(.)\1{3})((?=.*[\d])(?=.*[A-Za-z])|(?=.*[^\w\d\s])(?=.*[A-Za-z])).{8,20}$/,
    EMAIL                    : /^[a-z0-9!#$%&'*+\/=?^_\`{|}~.-]+@[a-z0-9]([a-z0-9-])+(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,
    FULL_SSN_FORMATTED       : /^\d{3}-\d{2}-\d{4}$/,
    FULL_SSN_MASK            : /(\d{0,3})(\d{0,2})(\d{0,4})/,
    FULL_SSN                 : /(^\d{9}$)/,
    LAST_4_SSN               : /^[0-9]{4}?$/,
    LAST_4_SSN_MASK          : /(\d{0,4})/,
    NON_DECIMAL_DIGITS       : /\D/g,
    SINGLE_ALPHANUMERIC      : /[^a-zA-Z0-9 ]/g,
    SINGLE_NUMERIC           : /[^0-9]/g,
    SIX_DIGIT                : /[0-9]{5}?$/,
    PHONE                    : /(^\d{10}$)/,
    PHONE_MASK               : /(\d{0,3})(\d{0,3})(\d{0,4})/,
    SYSTEM_NUMBER_REGEX      : /(^\d{1,7}$)/,
    WEIGHT_MASK              : /(\d{0,3})/,
    ZIPCODE_FULL             : /^[0-9]{5}([- /]?[0-9]{4})?$/,
    ZIPCODE_FULL_MASK        : /(\d{0,5})(\d{0,4})/,
    ZIPCODE                  : /^[0-9]{5}?$/,
    ZIPCODE_MASK             : /(\d{0,5})/,
    DATE_SHORT               : /(\d{2})\/(\d{2})/,
    DATE_SHORT_CCEXPIRE      : /^(1[0-2]|0[1-9]|\d)\/(2[3-9]|3[0-9])/,
    DATE_SHORT_MASK          : /(\d{0,2})(\d{0,2})/,
    REMOVE_PHONE_MASK        : /[()-\s]/g,
    REMOVE_SSN_MASK          : /[-\s]/g,
    REMOVE_ZIPCODE_MASK      : /[-]/g,
    DATE_MONTH               : /^(0|0?[1-9]|1?[0-2])$/,
    DATE_DAY                 : /^((0|0)?[0-9]|1?[0-9]|2?[0-9]|3?[0-1])$/,
    DATE_YEAR                : /^(19[0-9]|20[0-4])|(19[0-9]\d|20[0-4]\d|2050)$/,
}

export enum MaskType {
    phone = 'phone',
    social = 'social',
    last4 = 'last4',
    last4WithMask = 'last4WithMask',
    systemNumber = 'systemNumber',
    weight = 'weight',
    zipCode = 'zipCode',
    currency = 'currency',
    numericValues = 'numericValues',
    date = 'date',
    shortDate = 'shortDate',
    shortDateCCExpire = 'shortDateCCExpire',
    singleAlphaNumeric = 'singleAlphaNumeric',
    singleNumeric = 'singleNumeric',
    none = "none",
}